/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import {
  FloorChildrenFragmentDoc,
  FloorFragmentDoc
} from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type FloorQueryVariables = Exact<{
  id: string
}>

export type FloorQuery = {
  __typename: "Query"
  floor?: {
    __typename: "Floor"
    id: string
    label?: string | null
    position: number
    createdAt: string
    updatedAt: string
    remark?: string | null
    hasClarificationRequest?: boolean | null
    children?: Array<{
      __typename: "Room"
      id: string
      label?: string | null
      number: string
      area?: number | null
      volume?: number | null
      utilization?: string | null
      height?: number | null
      personsNumber?: number | null
      airVolumePerArea?: number | null
      airVolumePerPerson?: number | null
      remark?: string | null
      sup?: number | null
      oda?: number | null
      eta?: number | null
      eha?: number | null
      tra?: number | null
      rca?: number | null
      ida?: number | null
      sec?: number | null
      soundPressureLevel?: number | null
      position: number
      createdAt: string
      updatedAt: string
      hasClarificationRequest?: boolean | null
      children?: Array<{
        __typename: "ProductPosition"
        id: string
        label?: string | null
        variantKey: string
        configurationKey?: string | null
        remark?: string | null
        quantity: number
        position: number
        displayPosition?: string | null
        isAlternative?: boolean | null
        price?: number | null
        priceGroup?: string | null
        hasClarificationRequest?: boolean | null
        references?: Array<{
          __typename: "ProductPositionInstallationReference"
          id: string
          title?: string | null
          permalink: string
          position: number
        }> | null
        addons?: Array<{
          __typename: "ProductPositionAddon"
          id: string
          variantKey: string
          parentProductType: string
        }> | null
        dimensioning?: {
          __typename: "ExternalDimensioningResult"
          transactionId: string
          environmentalVars?: Array<any> | null
          variantKeyData?: any
          dllVersion?: string | null
          language?: string | null
          technicalData?: Array<
            | {
                __typename: "ExternalDimensioningTechnicalDataDllVersion"
                dllVersion: string
              }
            | {
                __typename: "ExternalDimensioningTechnicalDataTable"
                header?: Array<string> | null
                content?: any
                summary?: string | null
                type?: string | null
              }
          > | null
          technicalInput?: Array<{
            __typename: "ExternalDimensioningTechnicalInput"
            name: string
            label?: string | null
            unit?: string | null
            value?: any
            userSelected: boolean
          }> | null
          supplementaryText?: Array<{
            __typename: "ExternalDimensioningSupplementaryText"
            text: string
          }> | null
          transferData?: {
            __typename: "ExternalDimensioningTransferData"
            origin?: string | null
          } | null
        } | null
      }> | null
    }> | null
  } | null
}

export const FloorDocument = gql`
  query Floor($id: ID!) {
    floor(id: $id)
      @rest(
        type: "Floor"
        endpoint: "floor"
        path: "/project-list/floors/{args.id}?include=subtree"
      ) {
      ...Floor
      ...FloorChildren
    }
  }
  ${FloorFragmentDoc}
  ${FloorChildrenFragmentDoc}
`

/**
 * __useFloorQuery__
 *
 * To run a query within a React component, call `useFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFloorQuery(
  baseOptions: Apollo.QueryHookOptions<FloorQuery, FloorQueryVariables> &
    ({ variables: FloorQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FloorQuery, FloorQueryVariables>(
    FloorDocument,
    options
  )
}
export function useFloorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FloorQuery, FloorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FloorQuery, FloorQueryVariables>(
    FloorDocument,
    options
  )
}
// @ts-ignore
export function useFloorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<FloorQuery, FloorQueryVariables>
): Apollo.UseSuspenseQueryResult<FloorQuery, FloorQueryVariables>
export function useFloorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FloorQuery, FloorQueryVariables>
): Apollo.UseSuspenseQueryResult<FloorQuery | undefined, FloorQueryVariables>
export function useFloorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FloorQuery, FloorQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FloorQuery, FloorQueryVariables>(
    FloorDocument,
    options
  )
}
export type FloorQueryHookResult = ReturnType<typeof useFloorQuery>
export type FloorLazyQueryHookResult = ReturnType<typeof useFloorLazyQuery>
export type FloorSuspenseQueryHookResult = ReturnType<
  typeof useFloorSuspenseQuery
>
export type FloorQueryResult = Apollo.QueryResult<
  FloorQuery,
  FloorQueryVariables
>
